import React from 'react'
import uniq from 'lodash/uniq'
import MatchChart from 'lib/components/charts/match-chart'
import XAxis from 'lib/components/charts/x-axis'
import YAxis from 'lib/components/charts/y-axis'
import Container from 'lib/components/charts/container'
import Title from './title'
import { scaleBand } from 'd3-scale'
import { getGutters } from 'lib/components/charts/layouts/gutters'
import Matrix from 'lib/components/charts/matrix'

class FactorCorrelationMatrix extends React.PureComponent {
  static defaultProps = {
    data: [],
    titlePadding: 30
  }

  getRows() {
    const { data } = this.props

    let x = data.map(d => d.x)
    let y = data.map(d => d.y)

    return uniq(x.concat(y))
  }

  render() {
    const { data, title, titlePadding, height, width } = this.props

    const rows = this.getRows()

    const x = scaleBand().domain(rows)

    const y = scaleBand().domain(rows.reverse())

    let { breakpoint, left, top, bottom, right } = getGutters({
      width: width,
      height: height,
      left: {
        ticks: y.domain()
      },
      bottom: {
        ticks: x.domain(),
        vertical: true
      }
    })

    // Add space for the title
    if (breakpoint === 'large') {
      top += titlePadding
    }

    x.range([left, width - right])
    y.range([height - bottom, top])

    const offsetX = x.bandwidth() / 2
    const offsetY = y.bandwidth() / 2

    return (
      <Container width={width} height={height}>
        <Title x={left} y={top - titlePadding} padding={0}>
          {title}
        </Title>

        <Matrix scaleX={x} scaleY={y} data={data} rows={rows} />

        <MatchChart breakpoint="small" width={width}>
          <XAxis
            scale={x}
            y={y.range()[0]}
            offset={offsetX}
            ticks={x.domain()}
            height={bottom}
          />
        </MatchChart>

        <MatchChart breakpoint="large" width={width}>
          <XAxis
            scale={x}
            y={y.range()[0]}
            offset={offsetX}
            ticks={x.domain()}
            height={bottom}
            vertical
          />
        </MatchChart>

        <YAxis scale={y} offset={offsetY} ticks={y.domain()} width={left} />
      </Container>
    )
  }
}

export default FactorCorrelationMatrix



// WEBPACK FOOTER //
// ./src/components/charts/factor-correlation-matrix.js